// File: src/components/finance/FinanceFAQ.jsx
import React, { useState } from "react";
import "../../styles/FinanceFAQ.css";

const FinanceFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How is my loan eligibility determined?",
      answer: "Your loan eligibility is determined based on several factors including your monthly income, existing EMIs, credit score, employment type (salaried or self-employed), and loan tenure. Our finance partners use these parameters to calculate the maximum loan amount you can avail."
    },
    {
      question: "What factors impact my pre owned car loan interest rate?",
      answer: "The interest rate for your used car loan depends on factors such as your credit score, loan amount, loan tenure, down payment percentage, your income level, and the age and condition of the vehicle. A higher credit score and larger down payment typically result in lower interest rates."
    },
    {
      question: "Is it possible to get 100% of the value of the car financed with a used car loan?",
      answer: "While it's possible in some cases, most lenders typically finance 80-90% of the car's value. The remaining amount needs to be paid as a down payment. However, eligibility for 100% financing depends on your credit profile, income, and the lender's policies."
    },
    {
      question: "I have not decided on a car, can I get a pre-approved loan?",
      answer: "Yes! You can get pre-approved for a car loan before selecting a vehicle. This helps you understand your budget and makes the buying process faster. The pre-approval is valid for a specific period, typically 30-90 days, during which you can choose your car."
    },
    {
      question: "What if I take a loan and return my car back in the 5-day guarantee period?",
      answer: "If you return the car within our 5-day money-back guarantee period, the loan process will be cancelled, and any disbursed amount will be returned to the lender. You won't be liable for any EMI payments, though minimal processing charges might apply depending on the lender's policy."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="finance-faq">
      <div className="faq-container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>Q. {faq.question}</span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className={`faq-icon ${activeIndex === index ? "rotate" : ""}`}
                >
                  <path
                    d="M6 9l6 6 6-6"
                    stroke="#0A0A0A"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className={`faq-answer ${activeIndex === index ? "show" : ""}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="help-center-link">
          <button className="visit-help-center">Visit help center</button>
        </div>
      </div>
    </section>
  );
};

export default FinanceFAQ;